<template>
    <div class="item-tour">
        <ul>
            <li>
                <div class="has-icon add-icon add-tour d-flex justify-content-between">
                    <div>
                        <p>{{value.title}}</p>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'ItemTourDay',
  props: {
    value: Object
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/itinerario/ItemTourDay.vue